export function getMobilePreviewWidth() {
    return "375px";
}
